export interface Work {
  id: string;
  title: string;
  generalInstrumentation: string;
  detailedInstrumentation?: string;
  duration?: string;
  year: number;
  description?: string;
  scoreUrl?: string;
  videoUrl?: string;
  soundcloudUrl?: string;
  category: WorkCategory;
  ensembleType?: string;
  premiere?: string;
  commissioner?: string;
}

export enum WorkCategory {
  CHORAL = "Choral",
  VOCAL = "Vocal",
  INSTRUMENTAL = "Instrumental",
}

// We'll load the actual works from the CSV file in the WorksContext provider
export const sampleWorks: Work[] = [];
